/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import { useFormik, useFormikContext } from 'formik'
import { getUserByToken, login } from '../core/_requests'
import { KTIcon, toAbsoluteUrl } from '../../../../_metronic/helpers'
import { useAuth } from '../core/Auth'
import { useFetchCommon } from '../../../../_metronic/helpers/crud-helper/useQuery'
import { useLocation } from 'react-router-dom'

const loginSchema = (isSwitchAccount = false) =>
  isSwitchAccount
    ? Yup.object().shape({})
    : Yup.object().shape({
      // mobile: Yup.string()
      //   .matches(/^\d*$/, 'Only numbers are allowed')
      //   .max(50, 'Maximum 50 symbols')
      //   .required('Mobile no required'),
      password: Yup.string()
        .min(3, 'Minimum 3 symbols')
        .max(50, 'Maximum 50 symbols')
        .required('Password is required'),
    })

const initialValues = {
  mobile: '',
  password: '',
  userType: '',
  franchise: '',
  facility: '',
  franchiseeId: '',
}
export function Login() {
  const [loading, setLoading] = useState(false)
  const { saveAuth, setCurrentUser, auth }: any = useAuth()
  const [lastLogin, setLastLogin] = useState<string>('CLIENT')
  const [isAdmin, setIsAdmin] = useState(false)

  const { pathname } = useLocation()
  const isSwitchAccount = pathname.includes('switch-account')
  useEffect(() => {
    if (isSwitchAccount && auth?.data) {
      setfetchFranchiseList(true)
      setshowSupplyChainUI(true)
      setTempAuth(auth)
    }
  }, [isSwitchAccount])
  // console.log('this is testing console. cb')
  useEffect(() => {
    if (localStorage.getItem('default')) {
      try {
        const temp: any = localStorage.getItem('default')
        const decode = atob(temp)
        setIsAdmin(decode === 'man')
        setLastLogin('ADMIN')
      } catch (error) {
        console.log('error', error)
      }
    }
  }, [localStorage.getItem('default')])

  const [tempAuth, setTempAuth] = useState<any>({})
  const [showPassword, setShowPassword] = useState(false)
  const [showSupplyChainUI, setshowSupplyChainUI] = useState(false)
  const [showFacilityManagerUi, setshowFacilityManagerUi] = useState(false)
  const [fetchFranchiseList, setfetchFranchiseList] = useState(false)
  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema(isSwitchAccount),
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setLoading(true)
      try {
        setStatus('')
        if (values.facility) {
          saveAuth({
            ...tempAuth,
            data: {
              ...tempAuth.data,
              franchiseeid: values.franchise,
              pickuppointid: values.facility,
              isSwitchAccount: false,
              pickuppointName: facilityList.filter((x) => x.value === values.facility)?.[0]?.label,
            },
          })
          const { data: user } = await getUserByToken(tempAuth.data.userId)
          setCurrentUser(user)
        } else {
          const { data: auth } = await login(
            values.mobile,
            values.password,
            lastLogin,
            values.franchiseeId
          )
          if (values.franchiseeId) {
            saveAuth(auth)
            const { data: user } = await getUserByToken(auth.data.userId)
            setCurrentUser(user)
          } else {
            if (lastLogin === 'PICKUP_POINT_STAFF') {
              setTempAuth(auth || {})
              setfetchFranchiseList(true)
              setshowSupplyChainUI(true)
              setSubmitting(false)
              setLoading(false)
            } else if (lastLogin === 'FRANCHISE_USER') {
              setTempAuth(auth || {})
              setshowFacilityManagerUi(true)
              setLoading(false)
            } else {
              saveAuth(auth)
              const { data: user } = await getUserByToken(auth.data.userId)
              setCurrentUser(user)
            }
          }
        }
      } catch (error) {
        console.error(error)
        saveAuth(undefined)
        setStatus('The login details are incorrect')
        setSubmitting(false)
        setLoading(false)
      }
    },
  })





  useEffect(() => {
    if ((showSupplyChainUI || showFacilityManagerUi) && tempAuth?.data) {
      localStorage.setItem('auth', JSON.stringify(tempAuth))
      window.dispatchEvent(new Event('localStorageChange')) // Add this line
    }
  }, [showSupplyChainUI, tempAuth])

  useEffect(() => {
    if (!showSupplyChainUI && !showFacilityManagerUi) {
      localStorage.removeItem('auth')
      window.dispatchEvent(new Event('localStorageChange')) // Add this line
    }
  }, [showSupplyChainUI, showFacilityManagerUi])










  useEffect(() => {
    if (formik.values.facility) {
      // setSubmitting(false)
      setLoading(false)
    }
  }, [formik])

  const { responseData: franchiseList } = useFetchCommon({
    api: `franchise`,
    isEnabled: fetchFranchiseList,
    isDropDown: true,
    auth: tempAuth?.data?.token || '',
    label: ['personalDetails', 'name'],
  })
  const { responseData: facilityList } = useFetchCommon({
    api: `facilities/${formik.values.franchise}`,
    isEnabled: !!formik.values.franchise,
    isDropDown: true,
    auth: tempAuth?.data?.token || '',
    label: ['personalDetails', 'name'],
  })

  // useEffect(() => {
  //   if (lastLogin === 'PICKUP_POINT_STAFF') {
  //     console.log('first')
  //     setshowSupplyChainUI(true)
  //   }
  // }, [lastLogin])

  const handleShowPassword = () => {
    setShowPassword(!showPassword)
  }

  const [count, setCount] = useState(0)
  const handleCount = (value) => {
    setCount(value)
    if (value === 11) {
      localStorage.setItem('default', btoa('man'))
    }
  }

  const makeSelectDropDown = (format = '', options: any = [], disabled = false) => {
    return (
      <select className='form-select form-select-solid fw-bolder' {...formik.getFieldProps(format)}>
        <option value=''>Select one...</option>
        {options.map((eachOption, eachInd) => (
          <option disabled={disabled} key={eachInd + 1 + ''} value={eachOption.value}>
            {eachOption.label}
          </option>
        ))}
      </select>
    )
  }
  return (
    <form
      className='form w-100'
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signin_form'
    >
      {(formik.status && (
        <div className='mb-lg-5 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      )) ||
        null}
      {showFacilityManagerUi ? (
        <>
          <div className='fv-row mb-7'>
            <label className='form-label fs-6 fw-bolder text-white'>Select supply chain</label>
            {makeSelectDropDown(
              'franchiseeId',
              tempAuth.data.franchises.map((x) => ({ label: x.name, value: x.id }))
            )}
          </div>
        </>
      ) : showSupplyChainUI ? (
        <>
          <div className='fv-row mb-7'>
            <label className='form-label fs-6 fw-bolder text-white'>
              Select supply chain / Project
            </label>
            {makeSelectDropDown('franchise', franchiseList)}
          </div>
          <div className='fv-row mb-7'>
            <label className='form-label fs-6 fw-bolder text-white'>Select facility</label>
            {makeSelectDropDown('facility', facilityList)}
          </div>
        </>
      ) : (
        <>
          <div className='fv-row mb-8'>
            <label className='form-label fs-6 fw-bolder text-white'>Logging in as</label>
            <select
              className='form-select form-select-solid fw-bolder'
              data-kt-select2='true'
              data-placeholder='Select option'
              data-allow-clear='true'
              data-kt-user-table-filter='two-step'
              data-hide-search='true'
              onChange={(e) => setLastLogin(e.target.value)}
              value={lastLogin}
            >
              ...({isAdmin && <option value='ADMIN'>ASM</option>}||{ }),
              <option value='CLIENT'>Admin</option>
              {/* <option value='FRANCHISE'>FRANCHISEE</option> */}
              <option value='FRANCHISE_USER'>Supply chain / Project manager</option>
              {/* <option value='PICKUP_POINT_STAFF'>Facility Manager</option>
              <option value='AUDITOR'>Auditor</option>
              <option value='SPONSOR'>Sponsor</option> */}
              +
              <option value='PICKUP_POINT_STAFF'>Operations</option>
              <option value='AUDITOR'>Field auditor</option>
              <option value='SPONSOR'>Impact Partner</option>
              <option value='CLIENT_USER'>Marketing</option>
              <option value='MARKETING'>Business development</option>
            </select>
          </div>
          <div className='fv-row mb-8'>
            <label
              onClick={() => handleCount(count + 1)}
              className='form-label fs-6 fw-bolder text-white'
            >
              Login
            </label>
            <input
              placeholder='Registered Email/Mobile No'
              {...formik.getFieldProps('mobile')}
              className={clsx(
                'form-control form-control-solid mb-3 mb-lg-0',
                { 'is-invalid': formik.errors.mobile },
                {
                  'is-valid': !formik.errors.mobile,
                }
              )}
              type='mobile'
              name='mobile'
              autoComplete='off'
            />
            {formik.errors.mobile && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span role='alert'>{formik.errors.mobile}</span>
                </div>
              </div>
            )}
          </div>
          {/* end::Form group */}
          {/* begin::Form group */}
          <div className='fv-row mb-3'>
            <label className='form-label fw-bolder text-white fs-6 mb-0'>Password</label>
            <input
              type={showPassword ? 'text' : 'password'}
              autoComplete='off'
              {...formik.getFieldProps('password')}
              className={clsx(
                'form-control bg-white',
                {
                  'is-invalid': formik.touched.password && formik.errors.password,
                },
                {
                  'is-valid': formik.touched.password && !formik.errors.password,
                }
              )}
            />
            <div style={{ marginLeft: '250px', marginTop: '-39px' }} onClick={handleShowPassword}>
              <KTIcon iconName={showPassword ? 'eye-slash' : 'eye'} className='fs-2hx' />
            </div>
            {formik.touched.password && formik.errors.password && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span role='alert'>{formik.errors.password}</span>
                </div>
              </div>
            )}
          </div>
          {/* end::Form group */}
        </>
      )}

      {/* begin::Wrapper */}
      <div className='d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8'>
        <div />
        {/* begin::Link */}
        <a
          href='https://asm-recyclx.com/contact.html'
          target='_blank'
          className='link-primary text-white'
          rel='noreferrer'
        >
          Forgot password?
        </a>
        {/* end::Link */}
      </div>
      {/* end::Wrapper */}

      {/* begin::Action */}
      <div className={`mb-2 grid grid-cols${showSupplyChainUI ? '-2 gap-2' : ''}`}>
        <button
          type='submit'
          id='kt_sign_in_submit'
          className='btn'
          style={{ backgroundColor: '#FFE500', color: 'black' }}
          disabled={
            showFacilityManagerUi
              ? formik.values.franchiseeId
                ? false
                : true
              : showSupplyChainUI
                ? formik?.values?.facility
                  ? false
                  : true
                : formik.isSubmitting || !formik.isValid
          }
        >
          {!loading && <span className='indicator-label'
            style={{ backgroundColor: '#FFE500', color: 'black' }}
          >Log in</span>}
          {loading && (
            <span className='indicator-progress' style={{ display: 'block' }}>
              Please wait...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
        {showSupplyChainUI && !isSwitchAccount && (
          <button
            type='button'
            onClick={() => {
              setshowSupplyChainUI(false)
              setTempAuth({})
            }}
            id='kt_sign_in_submit'
            className='btn btn-secondary'
            // style={{backgroundColor: '#40C057', color: 'black'}}
            disabled={formik.isSubmitting || !formik.isValid}
          >
            {<span className='indicator-label'>Back</span>}
          </button>
        )}
      </div>
      {/* end::Action */}
    </form>
  )
}
